import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { ugcCommentShape, catalogBibShape } from '@bibliocommons/bc-prop-types';
import { ChevronLink } from '@bibliocommons/base-links';
import { ExpandableText } from '@bibliocommons/expandable';
import Heading from '@bibliocommons/heading';
import UgcList from 'app/components/bibs/shared/ugc/UgcList';
import CommentDisplayContainer from 'app/components/bibs/shared/ugc/CommentDisplay';
import { ContentWarningPanelContainer } from 'app/components/bibs/shared/ugc/ContentWarningPanel';
import { CommentEditorContainer } from 'app/components/bibs/shared/ugc/CommentEditor';

import './CommunityComments.scss';

export default class CommunityComments extends React.PureComponent {
  handleSuccess = () => {
    const metadataId = this.props.catalogBib.get('metadataId');
    this.props.bibsActions.fetchUGC(metadataId);
  };

  renderEditor = () => {
    const { catalogBib, currentUserComments } = this.props;

    // If current user hasn't submitted a comment for this bib, render a comment editor
    // Current user's comment will always be first in the list of comments
    return (
      !currentUserComments.get(catalogBib.get('metadataId')) && (
        <CommentEditorContainer catalogBib={catalogBib} handleSuccess={this.handleSuccess} />
      )
    );
  };

  renderComment = comment => {
    return (
      <CommentDisplayContainer
        comment={comment}
        catalogBib={this.props.catalogBib}
        handleDeleteSuccess={this.handleSuccess}
      >
        <ExpandableText
          text={comment.get('comment')}
          truncateCount={240}
          expandLinkHref={`#read-more-ugc-display-${comment.get('id')}`}
          textKey="comment"
        />
      </CommentDisplayContainer>
    );
  };

  render() {
    const { catalogBib, comments, summary } = this.props;
    const totalCommentsCount = summary.getIn(['comments', 'total']);
    const displayedCommentsCount = comments.size;

    return (
      <section className="cp-community-comments">
        <Heading tagName="h3" size="medium" variant className="community-comments-subtitle">
          <FormattedMessage id="community_comments_section" />
        </Heading>
        <UgcList
          items={comments}
          catalogBib={this.props.catalogBib}
          transactions={this.props.commentsTransactions}
          renderItem={this.renderComment}
          renderEditor={this.renderEditor}
          contentType="community_comments"
        >
          <ContentWarningPanelContainer />
        </UgcList>
        {totalCommentsCount > displayedCommentsCount && (
          <ChevronLink
            className="all-comments"
            dataKey="all-comments"
            href={`/v2/record/${catalogBib.get('metadataId')}/comments`}
          >
            <FormattedMessage id="view_all_comments" values={{ count: totalCommentsCount }} />
          </ChevronLink>
        )}
      </section>
    );
  }
}

CommunityComments.propTypes = {
  comments: ImmutablePropTypes.listOf(ugcCommentShape),
  currentUserComments: ImmutablePropTypes.mapOf(ugcCommentShape),
  commentsTransactions: ImmutablePropTypes.map.isRequired,
  summary: ImmutablePropTypes.map,
  catalogBib: catalogBibShape.isRequired,
  bibsActions: PropTypes.objectOf(PropTypes.func).isRequired
};
